import { activeBeat, type BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { timelineRailAxisY } from "../../marker/MarkerMetrics/metrics";
import { activeBranchOffsetY } from "../../rail/RailBranchMotion/motion";
import { computeSceneMotion, timelineHomeMarkerCenterX } from "@/lib/timeline/scene/SceneMotion/motion";
import { timelineCameraZoom } from "../TimelineCameraZoom/zoom";
import type { TimelineViewTransform } from "../ViewTransform/transform";
import { viewTransformCenteredOn } from "../ViewTransform/transform";

export function computeTimelineHomeView(
  layout: BookTimelineLayout,
  stageW: number,
  stageH: number,
  viewportWidth: number,
  playheadMs = 0,
  zoom?: number,
): TimelineViewTransform {
  const beat = activeBeat(layout, playheadMs);
  const count = beat?.characterIds.length ?? 2;
  const motion =
    layout.totalDurationMs > 0
      ? computeSceneMotion(playheadMs, viewportWidth, layout.totalDurationMs)
      : {
          groupCenterX: timelineHomeMarkerCenterX(viewportWidth),
          gridScrollPx: 0,
        };
  const nextZoom = zoom ?? timelineCameraZoom(stageW, count);
  const label = beat?.locationPath?.[0] ?? beat?.locationLabel ?? "";
  return viewTransformCenteredOn(
    motion.groupCenterX,
    timelineRailAxisY() + activeBranchOffsetY(layout.rail.branches, label, playheadMs),
    nextZoom,
    stageW,
    stageH,
  );
}
